import * as React from 'react';

export const ExternalPlaceholder: React.FC = () => (
  <p>This is a placeholder for the external-facing site</p>
);
